import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO
 */
export const cacheCreate = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.create.success
      .observe()
      .pipe(
        rxjs.map(action =>
          action.data.response
            ? plugin.collection.plugins.cachePlugin.feature.actions.put
                .from(action)
                .create({ entities: action.data.response })
            : store.effects.SKIP,
        ),
      ),
)
